import { useEffect, useState } from 'react';
/**
 * @see https://usehooks.com/useMedia
 * @example
 * // single query
 * const isGreaterThanMedium = useMedia<boolean>([mq.greaterThanMedium], [true], false)
 * @example
 * // multiple queries
 * const columns = useMedia<number>([mq.small, mq.medium, mq.large], [1, 2, 4], 4)
 */
function useMedia(queries, values, defaultValue) {
    // Array containing a media query list for each query
    const mediaQueryLists = queries.map(q => window.matchMedia(q));
    // Function that gets value based on matching media query
    const getValue = () => {
        // Get index of first media query that matches
        const index = mediaQueryLists.findIndex(mql => mql.matches);
        // Return related value or defaultValue if none
        return (values === null || values === void 0 ? void 0 : values[index]) || defaultValue;
    };
    // State and setter for matched value
    const [value, setValue] = useState(getValue);
    useEffect(() => {
        /*
         * Event listener callback
         * NOTE: By defining getValue outside of useEffect we ensure that it has
         * current values of hook args (as this hook callback is created once on mount).
         */
        const handler = () => setValue(getValue);
        // Set a listener for each media query with above handler as callback.
        mediaQueryLists.forEach(mql => {
            mql.addListener(handler);
        });
        // Remove listeners on cleanup
        return () => {
            mediaQueryLists.forEach(mql => mql.removeListener(handler));
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [] // Empty array ensures effect is only run on mount and unmount
    );
    return value;
}
export default useMedia;
